<template>
  <div class="esterno">
    <br />
    <div class="contorno">
      <h4 class="">Aperi Speak è un podcast che parla di passioni.</h4>
      <h4 class="">
        Ad ogni puntata, un ospite ci parla della sua esperienza e ci racconta
        cosa lo muove nella vita.
      </h4>
    </div>
    <br />
    <div class="contorno">
      <h4 class="">
        Disponibile su tutte le piattaforme (Spotify, Google Podcast, Apple
        Podcast...)
      </h4>
    </div>
    <br />
    <div class="autori">
      <div class="contorno_i">
        <a
          class="no_dec"
          target="_blank"
          href="https://www.instagram.com/giacomo.notaro"
        >
          <h4 class="a_text">Giacomo Notaro</h4>
        </a>
      </div>
      <div class="contorno_i">
        <a
          class="no_dec"
          target="_blank"
          href="https://www.instagram.com/the_pec"
        >
          <h4 class="a_text">Andrea Pecoroni</h4>
        </a>
      </div>
    </div>
    <br />
    <div class="contorno">
      <h4 class="">
        Un ringraziamento speciale per il "supporto informatico" va a
      </h4>
    </div>
    <br />
    <div class="contorno_i">
        <a
          class="no_dec"
          target="_blank"
          href="https://www.instagram.com/ale_ragusi"
        >
          <h4 class="a_text">Alessandro Ragusi</h4>
        </a>
      </div>
      <br>
      <br>
      <br>
  </div>
</template>

<style>
.no_dec {
  text-decoration: inherit !important;
  color: inherit !important;
}

.a_text {
  margin-bottom: 0%;
}
.autori {
  display: flex;
  justify-content: center;
  align-items: center;
}
.contorno {
  color: #2c3e50;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 5px 5px;
  /* border: 2px solid #961313; */
  border-radius: calc(10px);
  background: #ccb7a4;
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
  padding: 1%;
  margin-bottom: 0;
}
.contorno_i {
  color: white;
  background: #2c3e50;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 5px 5px;
  /* border: 2px solid #961313; */
  border-radius: calc(10px);
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
  padding: 1%;
  margin-bottom: 0;
  cursor: pointer;
}
.titolo-text {
  font-weight: bold;
}
</style>
